export const VIDEO_ICON_CLASS_NAME = 'video-icon-class';
export const AUDIO_ICON_CLASS_NAME = 'audio-icon-class';
